import React, { useContext, useEffect, useState } from "react";

import { Spin } from "antd";
import axios from "axios";
import PsContext from "../../../context";
import { APP_TYPE, COLLEGE, DB_POSTFIX } from "../../../utils";
import { ServiceUrl } from "../../../utils/serviceUrl";
import { Card, Col, Row, Modal, Button } from "react-bootstrap";

const Announcement = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [announcementList, setAnnouncementList] = useState([]);

  // Full view state
  const [viewImg, setViewImg] = useState(null);
  const [showView, setShowView] = useState(false);

  useEffect(() => {
    loadData();
  }, []);

  const handleImageClick = (e) => {
    if (e.target.tagName === "IMG" && e.target.classList.contains("show-img")) {
      setViewImg(e.target.src);
      setShowView(true);
    }
  };

  const loadData = () => {
    setLoader(true);
    let url = "";
    if (APP_TYPE == "SAAS") url = "?sadb=" + DB_POSTFIX;
    axios.get(ServiceUrl.ADMISSION.ANNOUNCEMENTS + url).then((res) => {
      if (res["data"].status == "1") {
        setDataList(res["data"].data);
      }
      setLoader(false);
    });
    if (APP_TYPE == "SAAS") url = "&sadb=" + DB_POSTFIX;
    axios
      .get(
        ServiceUrl.ADMISSION.CUSTOM_PAGE +
          "?slug=admission-helpline-numbers" +
          url,
      )
      .then((res) => {
        if (res["data"].status == "1") {
          setAnnouncementList(res["data"].data);
        }
        setLoader(false);
      });
  };

  const renderHtmlText = () => {
    if (context.settingValue("enable_helpline_number") == 1) {
      return (
        announcementList &&
        announcementList.id && (
          <center>
            <div
              className="p-2 mb-2 fs-15 border-bottom"
              onClick={handleImageClick}
              dangerouslySetInnerHTML={{
                __html: announcementList.content_html,
              }}
            />
          </center>
        )
      );
    } else {
      return dataList.map((item) => (
        <center key={item.id}>
          <div
            className="p-2 mb-2 fs-15 border-bottom"
            onClick={handleImageClick}
            dangerouslySetInnerHTML={{ __html: item.content_html }}
          />
        </center>
      ));
    }
  };

  const renderHtmlTextCard = () => {
    return dataList.map((item) => (
      <center key={item.id}>
        <div
          className="p-2 mb-2 fs-15 border-bottom"
          onClick={handleImageClick}
          dangerouslySetInnerHTML={{ __html: item.content_html }}
        />
      </center>
    ));
  };

  if (props.type && props.type == "card") {
    return (
      <>
        <Card className="border-0">
          <Card.Body>
            <div className="ps-v-marquee-container">
              <div className="ps-v-marquee-content">{renderHtmlTextCard()}</div>
            </div>
          </Card.Body>
        </Card>
      </>
    );
  } else {
    return (
      <>
        <h4
          className="fw-800 text-dark mb-4 fs-18 position-relative pb-2"
          style={{ fontFamily: "Outfit, sans-serif" }}
        >
          Latest Announcements
          <span
            className="position-absolute bottom-0 start-0 bg-primary"
            style={{ width: "40px", height: "3px", borderRadius: "2px" }}
          ></span>
        </h4>
        <Spin spinning={loader}>
          <div className="bg-white border-0 shadow-none">
            {context.settingValue("enable_helpline_number") == 1 ? (
              <div className="w-100"> {renderHtmlText()} </div>
            ) : (
              <div
                className="ps-v-marquee-container"
                style={{ height: "400px" }}
              >
                <div className="ps-v-marquee-content">{renderHtmlText()}</div>
              </div>
            )}
          </div>
        </Spin>

        <Modal
          show={showView}
          onHide={() => setShowView(false)}
          centered
          size="xl"
          dialogClassName="lightbox-modal"
          aria-labelledby="full-image-view"
        >
          <div
            className="lightbox-close-btn"
            onClick={() => setShowView(false)}
          >
            <i className="fa-solid fa-xmark fs-24"></i>
          </div>
          <Modal.Body className="p-0 text-center">
            <img
              src={viewImg}
              className="img-fluid rounded-3 shadow-lg"
              style={{ maxHeight: "90vh", width: "auto" }}
              alt="Full View"
              onClick={(e) => e.stopPropagation()}
            />
          </Modal.Body>
        </Modal>
      </>
    );
  }
};

export default Announcement;
